import { TRIGGER_CLASS } from './constants';

// Delegated (not per-element) so it also picks up trigger elements added to
// the host page after this loader ran — ports the document.addEventListener
// click-delegation pattern from scheduler-embed's app/init.ts.
export function registerOpenTrigger(open: () => void): void {
  document.addEventListener('click', (event) => {
    const { target } = event;

    if (target instanceof Element && target.closest(`.${TRIGGER_CLASS}`)) {
      open();
    }
  });
}
